import React from 'react';
import ShoppingCartManager from 'webshop/js/shopping-cart-manager';

var ProductRowMixin = {
    getInitialState: function () {
        ShoppingCartManager.ShoppingCartManager.on('change', this.updateButton);

        return {
            count: this.capCount(this.props.initial_count || 4),
            waitingCartUpdate: false,
        };
    },
    updateButton: function() {
        this.setState({waitingCartUpdate: false});
    },
    capCount: function(count) {
        if (this.props.non_stock_product) {
          return Math.min(count, this.props.supplier_stock - this.props.cart_count);
        }
        if (this.props.delivery_time) {
            return count;
        }
        return Math.min(count, this.props.stock_total - this.props.cart_count);
    },
    handleCountChange: function (newCount) {
        this.setState({count: this.capCount(newCount)});
    },
    componentWillReceiveProps: function(props) {
        var count = Math.min(this.state.count,
                             props.stock_total - props.cart_count);
        if (this.props.delivery_time) {
            count = this.state.count;
        }
        this.setState({
            count: count
        });
    },
    handleAddToCart: function () {
        if (this.state.waitingCartUpdate ||
            (this.props.non_stock_product && this.props.supplier_stock <= 0) ||
            (!this.props.delivery_time &&
             (this.props.stock_total - this.props.cart_count < this.state.count ||
              !this.state.count))) {
            return;
        }
        const tireTypes = {
            'summer': 'Kesärenkaat',
            'friction': 'Kitkarenkaat',
            'studded': 'Nastarenkaat',
            'truck': 'KA',
            'work': 'TK',
            'race': 'Kilparenkaat',
            'other': 'Muut renkaat',
        }

        let category = '';
        if (this.props.product_type == 'tire') {
          category = `${tireTypes[this.props.tire_type]}${this.props.used ? ' käytetyt' : ''}`;
        } else {
          category = `${this.props.wheel_type == 'alloy' ? 'Alumiinivanteet' : 'Peltivanteet'}${this.props.used ? ' käytetyt' : ''}`;
        }

        const productData = [{
            'name': this.props.brand + ' ' + this.props.model,
            'id': this.props.id,
            'price': this.props.unit_price,
            'brand': this.props.brand,
            'quantity': parseInt(this.state.count),
            'category': category,
        }];
        dataLayer.push({
          'event': 'ecomAddToCart',
          'ecommerce': {
            'currencyCode': 'EUR',
            'add': {
                'actionField': {
                  'list': category.toLowerCase().replace(' käytetyt', ''),
                },
                'products': productData
            }
          }
        });
        this.setState({waitingCartUpdate: true});
        var data = {
            product: this.props.id,
            count: this.state.count
        };
        if (this.props.car) {
            data['brand'] = this.props.car.brand;
            data['model'] = this.props.car.model;
            data['details'] = this.props.car.details;
        }
        if (this.props.is_blank) {
          ShoppingCartManager.blankDialog('id='+this.props.id, (blankData) => {
            ShoppingCartManager.ShoppingCartManager.add({
              product: this.props.id,
              count: this.state.count,
              ...blankData,
            });
            this.setState({waitingCartUpdate: false});
          });
        } else {
          ShoppingCartManager.ShoppingCartManager.add(data);
        }
    },
    renderAddToCart: function () {
        var addBtnClass = '',
            updating = this.state.waitingCartUpdate,
            incoming = null,
            buttonImg = null,
            showContactSales = false;

        if (!this.state.count && !this.props.delivery_time) {
            addBtnClass = 'disabled';
            if (this.props.incoming) {
                var text;

                addBtnClass += ' incoming';
                if (this.props.incoming_date) {
                    incoming = "Tulossa " + this.props.incoming_date;
                } else {
                    incoming = "Tulossa";
                }
            }
        }

        if (this.props.archived || (this.props.non_stock_product && this.props.supplier_stock <= 0)) {
          addBtnClass = 'disabled';
          incoming = "Ei saatavilla";
          showContactSales = true;
        }

        if (updating) {
            buttonImg = (<i className="fa fa-spinner fa-spin"
                            style={{color: 'white'}}>
                         </i>);
        } else {
            buttonImg = <img src="/static/nettivanne/webshop/img/icon-cart.png" />;
        }
        return (
          <div>
            <div>
              <div className={"add-to-cart " + addBtnClass}
                   onClick={this.handleAddToCart}>
                <span className="helper"></span>
                {incoming ? incoming : "OSTA"}
              </div>
            </div>
            { showContactSales && (
              <div className="buy-btn-msg">
                <small><a href="/yhteystiedot/">Ota yhteyttä myyntiimme</a></small>
              </div>
            )}
          </div>
        );
    }
};

export default ProductRowMixin;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/product-row-mixin.js
 **/